import { render, staticRenderFns } from "./coinExchange.vue?vue&type=template&id=fe2a04a8&scoped=true&"
import script from "./coinExchange.vue?vue&type=script&lang=js&"
export * from "./coinExchange.vue?vue&type=script&lang=js&"
import style0 from "./coinExchange.vue?vue&type=style&index=0&id=fe2a04a8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2a04a8",
  null
  
)

export default component.exports